<template>
  <div class="column is-4 game-search">
    <label class="label is-small is-white">Enter your region to find your local calendar</label>
    <div class="field has-addons is-flex">
      <div class="control has-icons-left">
        <input
          v-model="region"
          class="input"
          type="text"
          placeholder="732"
          @keydown.enter="search()"
        >
        <span class="icon is-small is-left">
          <i class="far fa-hashtag" />
        </span>
      </div>
      <div
        class="control"
        @click="search()"
      >
        <a class="button is-black br-radius">
          <span class="icon is-right">
            <i class="far fa-search" />
          </span>
        </a>
      </div>
      <span class="ml-4 mt-1">OR</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LocationRegion',
    data () {
      return {
        region: ''
      }
    },
    methods: {
      search () {
        if (this.region) {
          this.$router.push({name: 'Calendar', params: {selectedRegion: {number: this.region}}})
        }
      }
    }
  }
</script>
